export default __webpack_public_path__ + "img/dBDwphrw.afae1e41.svg";